export default __webpack_public_path__ + "static/media/CHF2P.ee3f50ea.png";